import { ButtonProps, Button } from '@material-ui/core';
import React from 'react';

export interface AppButtonProps extends Omit<ButtonProps, 'children'> {
  // iconLeft?: React.ReactElement<any, any>;
  text: React.ReactNode;
}

const AppButton = ({ text, style, ...props }: AppButtonProps) => {
  return (
    <Button
      variant="contained"
      color="secondary"
      {...props}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 8,
        padding: '0.5rem 1.5rem 0.5rem 1.5rem',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        maxHeight: 42.5,
        ...style,
      }}
    >
      {/* {iconLeft &&
        React.cloneElement(iconLeft, { style: { marginRight: '1rem' } })} */}
      {text}
    </Button>
  );
};

export default React.memo(AppButton);
